import helpers from '../helpers';

const $slider = $('.js-ages-slider');
const $item = $slider.find('.age');
const $cards = $('.age__cards');
const $text = $('.age__text');

function setCurrent($current) {
	const id = $current.index() + 1;

	$cards.add($text).removeClass('is-active');
	$cards.add($text).filter(`[data-id="${id}"]`).addClass('is-active');
	$current.addClass('age--current');
	$current
		.prev()
		.addClass('age--prev')
		.prev()
		.addClass('age--prevBefore')
		.prev()
		.addClass('age--prevBeforeBefore')
		.prev()
		.addClass('age--prevBeforeBeforeBefore');
	$current
		.next()
		.addClass('age--next')
		.next()
		.addClass('age--nextAfter')
		.next()
		.addClass('age--nextAfterAfter')
		.next()
		.addClass('age--nextAfterAfterAfter');

	setTimeout(() => {
		$slider.css({
			paddingBottom: $text.filter(`[data-id="${id}"]`).height(),
		});
	}, 100);
}

function init() {
	$slider
		.not('.slick-initialized')
		.on('init', () => {
			$slider.find('.slick-slide').each((index, slide) => {
				const $slide = $(slide);
				const $current = $slide.filter('.slick-current');

				if ($current.length) {
					setTimeout(() => {
						setCurrent($current);
					}, 500);
				}
			});
		})
		.slick({
			rows: 0,
			speed: 1000,
			infinite: false,
			initialSlide: helpers.isMobile() ? 0 : 2,
			swipeToSlide: true,
			variableWidth: true,
			prevArrow: '<button class="slick-arrow ages__button ages__button--prev btn" type="button" title="Предыдущий слайд"><svg><use xlink:href="./images/sprites.svg#arrow"></use></svg></button>',
			nextArrow: '<button class="slick-arrow ages__button ages__button--next btn" type="button" title="Следующий слайд"><svg><use xlink:href="./images/sprites.svg#arrow"></use></svg></button>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						variableWidth: false,
					},
				},
			],
		})
		.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
			const $current = $(slick.$slides.get(nextSlide));
			$item.removeClass('age--current age--prev age--prevBefore age--prevBeforeBefore age--prevBeforeBeforeBefore age--next age--nextAfter age--nextAfterAfter age--nextAfterAfterAfter');

			if ($current.length) {
				if (helpers.isMobile() && $current.hasClass('age--70')) {
					$slider.css('transition-delay', '0.5s');
				} else {
					$slider.css('transition-delay', '0s');
				}

				setCurrent($current);
			}
		});

	$item.on('click.ages', (e) => {
		const id = $(e.currentTarget).data('slick-index');

		$slider.slick('slickGoTo', id);
	});

	helpers.$window.on('resize', () => {
		$slider.slick('resize');
		const $current = $slider.find('.slick-current');

		$item.removeClass('age--current age--prev age--prevBefore age--prevBeforeBefore age--prevBeforeBeforeBefore age--next age--nextAfter age--nextAfterAfter age--nextAfterAfterAfter');

		if ($current.length) {
			setCurrent($current);
		}
	});
}

function destroy() {
	if ($slider.hasClass('slick-initialized')) {
		$slider.slick('destroy');
	}

	$item.off('.ages');
}

export default {
	init,
	destroy,
};
